/*
 * File: ApplicationService.ts
 * Project: receiving-rules
 * -----
 * Last Modified: 01 Oct 2020 4:59:27 pm
 * -----
 * Copyright (c) 2020 Elegant Software Solutions All rights reserved.
 */

// import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import { HTTPStatusCodes } from 'common/enums/HTTPStatusCodes';
import { ApplicationModel } from '../models/ApplicationModel';
import { DTOModel } from '../models/DTOModel';

// import MockData from '../api/MockApplication.json';

const freddyCadabbyBaseUrl = process.env.REACT_APP_FREDDY_CADABBY_BASE_URL;
const functionsKey = process.env.REACT_APP_API_HOST_KEY_FREDDY_CADABBY;

const getApplication = async (token: string): Promise<DTOModel<ApplicationModel | null>> => {
  const axiosOptions: AxiosRequestConfig = {
    headers: {
      authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      'x-functions-key': functionsKey
    },
    method: 'get',
    url: `${freddyCadabbyBaseUrl}/applications/${process.env.REACT_APP_APPLICATION_ID}`
  };

  const response: DTOModel<ApplicationModel | null> = {
    data: null,
    error: null,
    status: null
  };

  try {
    const resp: AxiosResponse<ApplicationModel | null> = await axios(axiosOptions);

    response.data = resp.data;
    response.status = resp.status;
  } catch (err) {
    const axiosError = err as AxiosError;

    response.status = (axiosError.response?.status as HTTPStatusCodes) ?? null;
    response.error = {
      message: axiosError.response?.data ?? 'Unable to get error message from server.',
      requestURL: axiosOptions.url as string,
      requestParams: { applicationId: process.env.REACT_APP_APPLICATION_ID }
    };
  }

  return response;
};

export const ApplicationService = {
  getApplication
};
